"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navbar = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const userStates_1 = require("../../../types/userStates");
const mapParamsHandler_1 = require("../../../utils/mapParamsHandler");
const CookieSettingsModal_1 = require("../../organisms/Modals/CookieSettingsModal/CookieSettingsModal");
const DesktopHeader_1 = __importDefault(require("./DesktopHeader"));
const MobileHeader_1 = require("./MobileHeader");
const S = __importStar(require("./Navbar.style"));
const Navbar = ({ isMapPage }) => {
    const [navMenuVisible, setNavMenuVisible] = (0, react_1.useState)(false);
    const [cookieSettingsModalOpen, setCookieSettingsModalOpen] = (0, react_1.useState)(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    const { currentUserSettings } = (0, mapParamsHandler_1.useMapParams)();
    const isTimelapseView = currentUserSettings === userStates_1.UserSettings.TimelapseView;
    const toggleMenuVisibility = () => setNavMenuVisible(!navMenuVisible);
    const handleOpenCookieSettings = () => {
        setCookieSettingsModalOpen(true);
        setNavMenuVisible(false);
    };
    const handleCloseCookieSettings = () => {
        setCookieSettingsModalOpen(false);
    };
    return (react_1.default.createElement(S.Header, null,
        isMapPage ? (react_1.default.createElement(MobileHeader_1.MobileHeader, { isTimelapseView: isTimelapseView, toggleMenuVisibility: toggleMenuVisibility, navMenuVisible: navMenuVisible, t: t, onOpenCookieSettings: handleOpenCookieSettings })) : (react_1.default.createElement(MobileHeader_1.MobileCalendarHeader, { t: t })),
        react_1.default.createElement(DesktopHeader_1.default, { isMapPage: isMapPage, isTimelapseView: isTimelapseView, navMenuVisible: navMenuVisible, toggleMenuVisibility: toggleMenuVisibility, t: t, onOpenCookieSettings: handleOpenCookieSettings }),
        react_1.default.createElement(CookieSettingsModal_1.CookieSettingsModal, { isOpen: cookieSettingsModalOpen, onClose: handleCloseCookieSettings })));
};
exports.Navbar = Navbar;
